import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 7,
  steps: [
    addColumns({
      table: 'messages',
      columns: [{ name: 'contacts', type: 'string', isOptional: true }]
    })
  ]
}
